module.exports = __webpack_public_path__ + "static/media/simon.e95e457b.jpg";